"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOneShoppingList = void 0;
const handle_error_1 = require("../../handle-error");
const buildPath = ({ shoppingListId }) => `/v1/bff/appro/shopping-lists/${shoppingListId}`;
const getOneShoppingList = (client, logger) => async (parameters) => {
    try {
        const response = await client.get(buildPath(parameters));
        return response.data;
    }
    catch (error) {
        (0, handle_error_1.handleError)(error, logger);
        return null;
    }
};
exports.getOneShoppingList = getOneShoppingList;
